<template>
  <v-container>
    <v-row class="mb-4 ga-4">
      <v-col
        class="ml-n2"
        cols="6">
        <v-row class="mb-4 ga-4">
          <v-col class="bordered bg-white">
            <v-table class="table_variant_surcharge">
              <tbody>
                <tr>
                  <td colspan="3">
                    <CalcInputNumber
                      :id="nodeId"
                      field="discount_rate_percentage_part"
                      :rules="[percents]" />
                  </td>
                </tr>
                <tr>
                  <td class="wide_col">
                    {{ $t("entities.part.fields.discount_part") }}
                  </td>
                  <td class="input_col">
                    <CalcOutput
                      :id="nodeId"
                      field="discount_part"
                      hide-label />
                  </td>
                  <td class="e_per_piece_col">
                    {{ $t("units.e_per_piece") }}
                  </td>
                </tr>

                <tr>
                  <td class="wide_col">
                    {{
                      $t(
                        "entities.variant.fields.ex_works_net_sales_price_part"
                      )
                    }}
                  </td>
                  <td class="input_col">
                    <CalcOutput
                      :id="nodeId"
                      field="ex_works_net_sales_price_part"
                      hide-label />
                  </td>
                  <td class="e_per_piece_col">
                    {{ $t("units.e_per_piece") }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="bordered bg-white">
            <v-table class="table_variant_surcharge">
              <tbody>
                <tr>
                  <td colspan="3">
                    <CalcInputNumber
                      :id="nodeId"
                      field="transport_costs_part"
                      :rules="[positive]"
                      :label="
                        $t('units.bracket_wrapper', {
                          message: $t(
                            'entities.part.fields.transport_costs_part'
                          ),
                          unit: $t('units.e_per_piece_long')
                        })
                      " />
                  </td>
                </tr>

                <tr>
                  <td colspan="3">
                    <CalcInputNumber
                      :id="nodeId"
                      field="customs_dutyies_part"
                      :rules="[positive]"
                      :label="
                        $t('units.bracket_wrapper', {
                          message: $t(
                            'entities.part.fields.customs_dutyies_part'
                          ),
                          unit: $t('units.e_per_piece_long')
                        })
                      " />
                  </td>
                </tr>

                <tr>
                  <td class="wide_col">
                    {{ $t("entities.variant.fields.net_sales_price_part") }}
                  </td>
                  <td class="input_col">
                    <CalcOutput
                      :id="nodeId"
                      field="net_sales_price_part"
                      hide-label />
                  </td>
                  <td class="e_per_piece_col">
                    {{ $t("units.e_per_piece") }}
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="bordered bg-white mr-n2 pb-12"
        cols="6">
        <NotesEditor
          :id="nodeId"
          field="net_sales_notes"
          :placeholder="$t('entities.variant.fields.base_data_notes')" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import CalcOutput from "../../../../components/Elements/CalcOutput.vue";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";
import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
const { t } = useTranslation();
const { positive, percents } = useCommonRules(t);

defineProps({
  nodeId: {
    type: String,
    required: true
  }
});
</script>

<style scoped lang="scss">
.table_variant_surcharge {
  font-size: 85%;

  .wide_col {
    max-width: 60%;
    min-width: 30%;
  }

  .input_col {
    width: 80px;
    padding: 0 6px !important;

    .v-field__input {
      min-height: 10px !important;
    }
  }

  .perc_col {
    width: 10px;
    padding: 0 6px !important;
  }

  .e_per_piece_col {
    width: 30px;
    padding: 0 6px !important;
    white-space: nowrap;
  }

  td,
  th {
    border-bottom: none !important;
  }

  .low-height {
    td,
    th {
      height: 40px !important;
    }
  }

  .v-field__input {
    padding: 4px 8px !important;
  }
}
</style>
